import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import {
  GridColumn,
  UserGridPreferenceUpdateDtoNew
} from '../../../modules/preferences/models/preferences.model';

import {
  PreferencesService
} from '../../../modules/preferences/preferences.service';


@Component({
  selector: 'app-column-preferences-dialog',
  templateUrl: './column-preferences-dialog.component.html',
  styleUrls: ['./column-preferences-dialog.component.scss']
})
export class ColumnPreferencesDialogComponent implements OnInit {

  @Output()
  orderChanged =
    new EventEmitter<GridColumn[]>();

  DashboardPrefernceList: GridColumn[] = [];


  constructor(
    public dialogRef:
      MatDialogRef<ColumnPreferencesDialogComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: any,

    private readonly _pref:
      PreferencesService
  ) { }


  ngOnInit(): void {

    if (this.data?.DashboardPrefernceList) {

    
      this.DashboardPrefernceList =
        this.data.DashboardPrefernceList.map(
          (column: GridColumn) => ({
            ...column
          })
        );

    
      this.DashboardPrefernceList.sort(
        (a, b) =>
          (a.SortOrder || 0) -
          (b.SortOrder || 0)
      );

   
      this.updateSortOrder();

      return;
    }

    if (this.data?.ScreenCode) {
      this.GetGridColumnsWithUserPreference();
    }
  }



  GetGridColumnsWithUserPreference(): void {

    this._pref
      .GetGridColumnsWithUserPreferenceAsync(
        this.data.ScreenCode
      )
      .subscribe({

        next: (res: GridColumn[]) => {

          this.DashboardPrefernceList =
            (res || []).map(
              (column: GridColumn) => ({
                ...column
              })
            );

          this.DashboardPrefernceList.sort(
            (a, b) =>
              (a.SortOrder || 0) -
              (b.SortOrder || 0)
          );

          this.updateSortOrder();
        },

        error: (err) => {

          console.error(
            'Error loading grid column preferences:',
            err
          );

          this.DashboardPrefernceList = [];
        }
      });
  }



  onColumnSelectionChanged(): void {

   
    this.emitChanges();

   
    this.savePreferences();
  }


  moveUp(column: GridColumn): void {

    const index =
      this.DashboardPrefernceList.indexOf(column);

    if (index <= 0) {
      return;
    }

    [
      this.DashboardPrefernceList[index - 1],
      this.DashboardPrefernceList[index]
    ] = [
        this.DashboardPrefernceList[index],
        this.DashboardPrefernceList[index - 1]
      ];

    this.updateSortOrder();

    this.emitChanges();

    this.savePreferences();
  }



  moveDown(column: GridColumn): void {

    const index =
      this.DashboardPrefernceList.indexOf(column);

    if (
      index < 0 ||
      index >=
      this.DashboardPrefernceList.length - 1
    ) {
      return;
    }

    [
      this.DashboardPrefernceList[index + 1],
      this.DashboardPrefernceList[index]
    ] = [
        this.DashboardPrefernceList[index],
        this.DashboardPrefernceList[index + 1]
      ];

    this.updateSortOrder();

    this.emitChanges();

    this.savePreferences();
  }



  private updateSortOrder(): void {

    this.DashboardPrefernceList.forEach(
      (column, index) => {

        column.SortOrder = index + 1;

      }
    );
  }


  private emitChanges(): void {

    
    const columns =
      this.DashboardPrefernceList.map(
        (column: GridColumn) => ({
          ...column
        })
      );

    this.orderChanged.emit(columns);
  }

  savePreferences(): void {

    if (
      !this.DashboardPrefernceList ||
      this.DashboardPrefernceList.length === 0
    ) {
      return;
    }

   
    this.updateSortOrder();


    const request =
      new UserGridPreferenceUpdateDtoNew();


    request.ScreenCode =
      this.data?.ScreenCode;


    request.Columns =
      this.DashboardPrefernceList
        .map(column => ({
          GridId: column.GridId,
          SortOrder: column.SortOrder,
          IsSelected: column.IsSelected
        }));


    this._pref
      .UpdateGridColumnPreferenceNew(request)
      .subscribe({

        next: (res) => {

        

          if (!res) {
            console.warn(
              'Grid preference update returned false.'
            );
          }
        },

        error: (err) => {

          console.error(
            'Error saving grid preferences:',
            err
          );

        }
      });
  }


  onCloseClick(): void {

   
    this.dialogRef.close(
      this.DashboardPrefernceList
    );
  }

}
